import React from 'react'
import {isEmpty} from 'lodash'
import {Redirect} from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'
import ActionCompareArrows from 'material-ui-legacy/svg-icons/action/compare-arrows'
import ActionCheckCircle from 'material-ui-legacy/svg-icons/action/check-circle'
import {deepOrange500, lightGreenA700} from 'material-ui-legacy/styles/colors'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DirectorForm from './DirectorForm'

import Resource from '../../stores/resource'
const DirectorStore = Resource('directors')

class EditDirector extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      director: (this.props.director || {}),
      changed: false,
      saved: false,
      error: '',
      snackbarMessage: ''
    }
  }

  _save = (attributes) => {
    // Adjust attributes
    attributes.phones = {
      office: attributes.officePhone,
      mobile: attributes.mobilePhone
    }

    // Remove display-only fields
    delete attributes.mobilePhone
    delete attributes.officePhone
    // Build new full name
    const newFullName = `${attributes.firstName} ${attributes.lastName}`
    // Update!
    DirectorStore.update(this.state.director.id, attributes)
    .then((result) => {
      this.setState({
        saved: true,
        changed: false,
        error: '',
        result: result,
        snackbarMessage: `Director "${newFullName}" saved!`
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _changed = (didChange) => this.setState({changed: didChange, saved: false})

  _closeErrorDialog = () => this.setState({error: ''})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect}/>

    const director = (isEmpty(this.state.director)) ? null : this.state.director

    const changed = this.state.changed
    const saved = this.state.saved

    return (
      <section>
        <DirectorForm
          formTitle={
            <span>
              {director.attributes.fullName}&nbsp;
              {changed && <ActionCompareArrows color={deepOrange500}/>}
              {saved && <ActionCheckCircle color={lightGreenA700}/>}
            </span>
          }
          director={director}
          changedCallback={this._changed}
          submitCallback={this._save}
          cancelCallback={() => this._redirectTo("/directors")}
        />

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't save your changes">
          <p>
            The director <strong>
              {director.attributes.fullName}
            </strong> remains unchanged.
          </p>
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditDirector



// WEBPACK FOOTER //
// ./src/components/Directors/EditDirector.jsx